// import React from 'react';

// const blogPosts = [
//   {
//     imgSrc: '/img/blog/blog-h-1-1.jpg',
//     title: 'Swift Dzire',
//     date: 'July 22, 2023',
//     content: 'Swift Dzire is a perfect sedan for local and outstation rides. Comfortable seating for 4 passengers and fuel efficiency makes it ideal for daily commutes and airport transfers.',
//   },
//   {
//     imgSrc: '/img/blog/blog-h-1-2.jpg',
//     title: 'Ertiga',
//     date: 'July 24, 2023',
//     content: 'The Maruti Ertiga is a spacious 7-seater MPV that’s ideal for family trips and group outings. Enjoy a smooth ride with ample boot space and comfort.',
//   },
//   {
//     imgSrc: '/img/blog/blog-h-1-3.jpg',
//     title: 'Innova Crysta',
//     date: 'Aug 21, 2023',
//     content: 'The Toyota Innova Crysta offers luxury and power in one ride. With seating for 7 and a plush interior, it’s perfect for business travel and long-distance journeys.',
//   },
//   {
//     imgSrc: '/img/blog/blog-h-1-4.jpg',
//     title: '17 Seater Tempo Traveller',
//     date: 'Sep 21, 2023',
//     content: 'Tempo Traveller is the go-to choice for group travel. With seating 17, it’s perfect for tours, events, and long trips with comfort and AC options.',
//   },
//   {
//     imgSrc: '/img/blog/blog-h-1-4.jpg',
//     title: '20 Seater Tempo Traveller',
//     date: 'Sep 21, 2023',
//     content: 'Tempo Traveller is the go-to choice for group travel. With seating 20, it’s perfect for tours, events, and long trips with comfort and AC options.',
//   },
//   {
//     imgSrc: '/img/blog/blog-h-1-2.jpg',
//     title: 'Mini Bus',
//     date: 'July 24, 2023',
//     content: 'Our Mini Buses are ideal for mid-size groups ranging from 18 to 26 passengers. Comfortable, air-conditioned, and perfect for school trips, corporate travel, and events.',
//   },
//   {
//     imgSrc: '/img/blog/blog-h-1-3.jpg',
//     title: '45 Seater Bus',
//     date: 'Aug 21, 2023',
//     content: 'The 45-seater bus is ideal for large-scale group travel. Spacious, safe, and air-conditioned, it’s best suited for tours, school outings, and office team travel.',
//   },
//   {
//     imgSrc: '/img/blog/blog-h-1-4.jpg',
//     title: '50 Seater Bus',
//     date: 'Sep 21, 2023',
//     content: 'Our 50-seater bus is built for comfort and convenience during long-distance travel. Ideal for corporate events, tourism, and pilgrimage groups.',
//   },
//   {
//     imgSrc: '/img/blog/blog-h-1-3.jpg',
//     title: 'AC Bus',
//     date: 'Aug 21, 2023',
//     content: 'AC buses offer unmatched comfort during summer travel or long-distance journeys. Suitable for corporate, personal, and wedding group travel across cities.',
//   },
// ];

// const Ourfleet = () => {
//   return (
//     <>
//       <div
//         className="breadcumb-wrapper"
//         // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
//       >
//         <div className="container z-index-common">
//           <div className="breadcumb-content">
//             <h1 className="breadcumb-title">Our Fleet</h1>
//             <div className="breadcumb-menu-wrap"></div>
//           </div>
//         </div>
//       </div>

//       <section className="space space-extra-bottom blog-wrapper">
//         <div className="container">
//           <div className="row vs-carousel"
//             data-slide-show="3"
//             data-arrows="false"
//             data-lg-slide-show="2"
//             data-md-slide-show="2"
//             data-sm-slide-show="1"
//             adaptiveheight="true"
//           >
//             {blogPosts.map((post, index) => (
//               <div className="col-xl-4" key={index}>
//                 <div className="vs-blog blog-style3">
//                   <div className="blog-img">
//                     <a href="#">
//                       <img src={post.imgSrc} alt={post.title} />
//                     </a>
//                   </div>
//                   <div className="blog-content">
//                     <h2 className="blog-title">
//                       <a href="#">{post.title}</a>
//                     </h2>
//                     <p className="blog-text">{post.content}</p>
//                     <a href="/booking" className="vs-btn style2 mt-2">Book Now</a>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Ourfleet;


import React from 'react';

const blogPosts = [
  {
    imgSrc: '/images/gallery/1.jpg',
    title: 'Swift Dzire',
    content: 'Swift Dzire is a perfect sedan for local and outstation rides. Comfortable seating for 4 passengers and fuel efficiency makes it ideal for daily commutes and airport transfers.',
  },
  {
    imgSrc: '/images/gallery/21.avif',
    title: 'Swift Dzire',
    content: 'Hyundai Aura is a perfect compact sedan for both local and outstation travel. With comfortable seating for 4 passengers, a spacious boot, and excellent fuel efficiency, it is ideal for daily commutes, business trips, and airport transfers.',
  },
  {
    imgSrc: '/images/gallery/2.jpg',
    title: 'Ertiga',
    content: 'The Maruti Ertiga is a spacious 7-seater MPV that’s ideal for family trips and group outings. Enjoy a smooth ride with ample boot space and comfort.',
  },
  {
    imgSrc: '/images/gallery/3.jpg',
    title: 'Innova Crysta',
    content: 'The Toyota Innova Crysta offers luxury and power in one ride. With seating for 7 and a plush interior, it’s perfect for business travel and long-distance journeys.',
  },
 

{
  imgSrc: '/images/gallery/19.jpg',
  title: 'Scorpio',
  content: 'The Mahindra Scorpio combines rugged performance with comfort, making it ideal for both city drives and off-road adventures. With spacious seating and modern features, it’s perfect for small group travel.',
},

{
  imgSrc: '/images/gallery/20.jpg',
  title: 'Tavera',
  content: 'The Chevrolet Tavera offers reliable comfort for family or business trips. With seating for 8 and good mileage, it’s a practical choice for intercity travel and daily commuting.',
},
{
  imgSrc: '/images/gallery/14.jpeg',
  title: 'Cruiser',
  content: 'The Force Cruiser is a robust and spacious vehicle, designed for group travel with seating for 13. It’s a great choice for events, tours, or long journeys, offering durability and basic comfort.',
},
 {
    imgSrc: '/images/gallery/4.jpg',
    title: '17 Seater Tempo Traveller',
    content: 'Tempo Traveller is the go-to choice for group travel. With seating 17, it’s perfect for tours, events, and long trips with comfort and AC options.',
  },
  {
    imgSrc: '/images/gallery/5.jpg',
    title: '20 Seater Tempo Traveller',
    content: 'Tempo Traveller is the go-to choice for group travel. With seating 20, it’s perfect for tours, events, and long trips with comfort and AC options.',
  },
  // {
  //   imgSrc: '/images/gallery/6.jpg',
  //   title: 'Mini Bus',
  //   content: 'Our Mini Buses are ideal for mid-size groups ranging from 18 to 26 passengers. Comfortable, air-conditioned, and perfect for school trips, corporate travel, and events.',
  // },
  // {
  //   imgSrc: '/images/gallery/7.jpg',
  //   title: '45 Seater Bus',
  //   content: 'The 45-seater bus is ideal for large-scale group travel. Spacious, safe, and air-conditioned, it’s best suited for tours, school outings, and office team travel.',
  // },
  // {
  //   imgSrc: '/images/gallery/8.jpg',
  //   title: '50 Seater Bus',
  //   content: 'Our 50-seater bus is built for comfort and convenience during long-distance travel. Ideal for corporate events, tourism, and pilgrimage groups.',
  // },
  // {
  //   imgSrc: '/images/gallery/9.jpg',
  //   title: 'AC Bus',
  //   content: 'AC buses offer unmatched comfort during summer travel or long-distance journeys. Suitable for corporate, personal, and wedding group travel across cities.',
  // },
];

const Ourfleet = () => {
  return (
    <>
      <div
        className="breadcumb-wrapper"
        // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Our Fleet</h1>
          </div>
        </div>
      </div>

      <section className="space space-extra-bottom fleet-wrapper">
        <div className="container">
          <div className="row">
            {blogPosts.map((post, index) => (
              <div className="col-xl-4 col-md-6 col-sm-12" key={index}>
                <div className="fleet-card">
                  {/* Logo Badge */}
            

                  <div className="fleet-img">
                    <img src={post.imgSrc} alt={post.title} />
                    <div className="fleet-overlay">
                      <a href="/booking" className="fleet-btn">Book Now</a>
                    </div>
                  </div>
                  <div className="fleet-content">
                    <h2 className="fleet-title">{post.title}</h2>
                    <p>{post.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Ourfleet;
